
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_REQUEST_IS_MALFORMED,
	WS_PROCESS_MESSAGE_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { publishAndAwait } from '../../../app/coreSlice';

export const addOrRemoveCustomerToPP = async ( data ) => {

	if (typeof data === 'undefined') {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const {
		pricingPlanId,
		customerCode,
	} = data;

	if ( !pricingPlanId || !customerCode ) {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'PRICING',
			subType: 'ADD_CUSTOMER',
			message: {
				pricingId: pricingPlanId,
				customerCode,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (error) {
		return;
	}

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	}

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	}

	return processMessage || null;
};

export default addOrRemoveCustomerToPP;